import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.partnerTransaction
)

export const selectTransactionError = createSelector(
    baseSelector,
    (state) => state.error
)
export const selectTransactionLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)
export const selectTransaction = createSelector(
    baseSelector,
    (state) => state.transaction
)